module.exports = __webpack_public_path__ + "static/img/3_1.a3a04fe3.jpg";